<template>
  <el-dialog :visible="visible" :title="title" @close="handleCancel" :close-on-click-modal="false" width="600px">
    <div v-loading="loading">
      <el-form ref="editSupplierForm" :model="editData">
        <el-form-item label="货号：">
          <el-autocomplete
            placeholder="请输入货号"
            ref="queryItemNo"
            :disabled="editData.id > 0"
            v-model="editData.itemNo"
            :trigger-on-focus="false"
            value-key="ItemNo"
            :fetch-suggestions="querySearchItemNo"
            @change="handleMatchItemNo()"
            @select="handleSeletedItemNo($event)"
            style="width: 300px"
          ></el-autocomplete>
        </el-form-item>
        <!--<el-form-item label="仓库：">
          <warehouse-select  :value.sync="editData.wID " select_style="width:300px;" :set_default="true"
            @handleChanged="handleWarehouseChanged" />
          
        </el-form-item>-->
        <el-form-item label="预警值：">
          <el-input v-model="editData.stockWarningValue" clearable placeholder="请输入预警值" style="width: 285px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave" v-loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
import { baseURL, successCode } from '@/config'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
export default {
  name: 'storageImport',
  components: {
    //WarehouseSelect,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '编辑库存预警',
      editData: {
        itemNo: '',
        stockWarningValue: '',
        productId: '',
        iD: 0,
        wID: 0,
      },
    }
  },
  methods: {
    open(data) {
      this.visible = true
      this.editData.id = data.id
      this.editData.itemNo = data.itemNo
      this.editData.stockWarningValue = data.stockWarningValue
      this.editData.productId = data.productId
      this.editData.wID = data.wID
    },
    handleCancel() {
      this.visible = false
    },
    handleWarehouseChanged(data) {
      this.editData.WName = data != null ? data.WName : ''
    },
    handleSeletedItemNo(selectedRow) {
      this.editData.productId = selectedRow.ProductID
    },
    handleMatchItemNo() {
      var that = this
      let selectedRow = that.searchItems.filter(i => i.ItemNo.toLowerCase() == that.editData.itemNo.toLowerCase())
      if (selectedRow.length > 0) {
        that.handleSeletedItemNo(selectedRow[0])
      } else {
        that.editData.productId = 0
      }
    },
    async querySearchItemNo(query, callback) {
      var that = this
      if (query !== '') {
        clearTimeout(that.timeout)
        that.timeout = setTimeout(async () => {
          //加上延时，避免段时间输入太多而请求太多次
          const { data } = await submit('/api/purchase/getProducts', {
            Keyword: query,
            GetSpecs: false,
            GetStock: false,
            FuzzySearch: true,
            WIDs: '',
          })
          that.searchItems = data
          if (callback != null) {
            callback(data)
          }
        }, 200)
      }
    },
    async handleSave() {
      if (!this.editData.itemNo) {
        this.$message({
          type: 'error',
          message: '请选择要配置库存预警的商品!',
        })
        return
      }
      // if (this.editData.wID <= 0) {
      //   this.$message({
      //     type: 'error',
      //     message: '请选择商品所属库存!',
      //   })
      //   return
      // }

      const result = await submit('/api/wms/stockWarn/editStockWarning', this.editData)
      if (result.success) {
        this.$message({
          type: 'success',
          message: '操作成功!',
        })
        this.handleCancel()
        this.$emit('handleSearch')
      }
    },
  },
}
</script>
<style scoped>
.xls-import {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.xls-import .btn-wrap {
  margin-top: 10px;
}
</style>
